import { FC } from 'react'
import { Alert, Link } from '@bbl-digital/snorre'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { removeToasterMessage } from 'shared/store/toaster'
import { getToasterMessages } from 'shared/store/toaster/selector'
import { Wrapper, Content } from './styles'

const Toaster: FC = () => {
  const messages = useSelector(getToasterMessages)
  const dispatch = useDispatch()
  const { push } = useHistory()

  if (!messages?.length) return null

  return (
    <Wrapper>
      {messages.map((message) => {
        const removeMessage = () => {
          if (!message.id) return
          dispatch(removeToasterMessage(message.id))
        }

        return (
          <Alert
            key={message.id}
            danger={message.type === 'danger'}
            success={message.type === 'success'}
            onClose={removeMessage}
          >
            <Content>
              {message.text}

              {message.url && (
                <Link small nopadding onClick={() => push(message.url!.link)}>
                  {message.url.title}
                </Link>
              )}
            </Content>
          </Alert>
        )
      })}
    </Wrapper>
  )
}

export default Toaster
